import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from '../services/analytics';

// /leads/1234 -> /leads/:id   so PostHog groups them into one row
const normalize = (pathname) =>
  pathname
    .replace(/\/\d+/g, '/:id')
    .replace(/\/[0-9a-f]{8}-[0-9a-f-]{27,}/gi, '/:uuid');

export const usePageviewTracking = () => {
  const location = useLocation();
  useEffect(() => {
    track('$pageview', {
      route: normalize(location.pathname),
      $current_url: window.location.href,
    });
  }, [location.pathname]);
};
